import { ModularizationResponse } from '../../@types/response-mkm';
import instance from './instance';

export async function getModularization(type: string) {
  const response = await instance.get<ModularizationResponse>(`/modularization/${type}`);

  return response.data;
}
